import { $freePost, $freeGet } from '@js/request'
import { FileSchema } from '@src/components/schema/operateSchema'

export interface ItemSchema {
  id: string
  orderno: number
  title: string
  type: string
  options: OptionSchema[]
  required: number
  groupid: string
  [k: string]: any
}

export interface OptionSchema {
  id: string
  title: string
  placeholder: string
  orderno: number
  isdefault: number
  isext: number
  tooltip: string
  checked: boolean | number
  result: string
  config_item_groupid: string
}

export async function submitRequest (d: {[k: string]: any}): Promise<void> {
  const res = await $freePost('/api/common/registrationResult', d)
  return res.data
}

export async function getDetailRequest (id: string): Promise<{ title: string, file: FileSchema[], items: ItemSchema[], bottom_file: FileSchema[] }> {
  const res = await $freeGet(`/api/common/registrationConfig/${id}?v=${Date.now()}`)
  return res.data
}

export async function getConfigRequest (idno: string, configkey: string): Promise<{ arbitratorid: string, configid: string }> {
  const res = await $freeGet('/api/common/registrationResult/getMaxCountinfo', {
    configkey,
    idno,
    v: Date.now()
  })
  return res.data
}

export interface InfoSchema {
  content: string
  title: string
  orderno: number
}

export async function getInfoRequest (idno: string, configkey: string): Promise<{ ischeck: number, data: InfoSchema[] }> {
  const res = await $freeGet('/api/common/registrationResult/checkinfo', {
    idno,
    configkey,
    v: Date.now()
  })
  return res.data
}
